// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toggle-accordion-button[data-v-0ace50c9]{cursor:pointer}.toggle-accordion-button[data-v-0ace50c9] :hover{color:#0d47a1}.toggle-accordion-button .when-open[data-v-0ace50c9]{display:block}.toggle-accordion-button .when-closed[data-v-0ace50c9]{display:none}[data-v-0ace50c9] .toggle-accordion-button.collapsed .when-closed{display:block}[data-v-0ace50c9] .toggle-accordion-button.collapsed .when-open{display:none}", ""]);
// Exports
module.exports = exports;
